import React from "react";
import Router from "./Router";
import "./assets/reset.css";
import "./assets/style.css";
import { Header } from "./components/Header";
import {
  AppVersionGateDialog,
  Footer,
  Loading,
  ScrollToTop,
} from "./components/UIkit";
import { Font } from "@react-pdf/renderer";
import NotoSansJP from "./components/PDF/fonts/NotoSansJP-Regular.ttf"; // フォントファイルのパス
import GoogleAnalistics from "./components/analitics/GoogleAnalistics";

// フォントを登録
Font.register({
  family: "NotoSansJP",
  src: NotoSansJP,
  fontStyle: "normal",
  fontWeight: "normal",
});
const App = () => {
  return (
    <GoogleAnalistics>
      <Loading>
        <ScrollToTop />
        <AppVersionGateDialog />
        <Header />
        <main className="c-main">
          <Router />
        </main>
      </Loading>
    </GoogleAnalistics>
  );
};
export default App;
